import { createClient } from "@supabase/supabase-js";

const supabaseUrl = 'https://xabwcwhoywjuzleozjym.supabase.co';
const supabaseKey = 'sb_publishable_quZU95KB1kVb8iKatB_bIw_HxgSaSB-';
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
